export default "__VITE_ASSET__Ckc1T_vS__"